import { useSelector } from "react-redux";

export const useSelectedPartnerCode = () => {
  const selectedOrganizationPartnerCode: string | null =
    useSelector(({ app }: any) => app?.distributionpartnercodes) || null;

  return selectedOrganizationPartnerCode;
};
